import React from "react";

import filtersConfig from "../../Config/filtersConfig";
import Accordion from "../../UI/Accordion/Accordion";
import CustomCategories from "./Categories/CustomCategories";
import CustomCheckbox from "./Checkbox/CustomCheckbox";
import CustomDatePicker from "./DatePicker/CustomDatePicker";
import CustomRangeSlider from "./RangeSlider/CustomRangeSlider";
const CustomFilters = (props) => {
    const { showInitial } = props;

    const activeFilters = filtersConfig.filter(
        (activeElements) => activeElements.active,
    );
    const initialFilters = activeFilters.filter(
        (initialElements) => initialElements.showInitial,
    );
    // eslint-disable-next-line
    const memoInitialList = initialFilters.map((element, index) => {
        switch (element.type) {
            case "checkbox":
                return (
                    <CustomCheckbox
                        key={index + "initial" + element.name}
                        className="search-filter"
                        panelTitle={element.label}
                        attribute={element.name}
                        operator={"or"}
                        limit={5}
                        showMore={"true"}
                        showMoreLimit={200}
                    />
                );
            case "datepicker":
                return (
                    <CustomDatePicker
                        key={index + "initial" + element.name}
                        panelTitle={element.label}
                        attribute={element.name}
                    />
                );
            case "range":
                return (
                    <CustomRangeSlider
                        key={index + "initial" + element.name}
                        panelTitle={element.label}
                        attribute={element.name}
                        // Optional parameters
                        unit={element.unit}
                    />
                );
            case "category":
                return (
                    <CustomCategories
                        key={index + "initial" + element.name}
                        panelTitle={element.label}
                        categories={element.levels}
                        attribute={element.name}
                    />
                );
            case "group":
                return (
                    <Accordion
                        header={element.label}
                        group={true}
                        key={index + " initial group accordion"}
                    >
                        {element.group
                            // eslint-disable-next-line
                            .map((element, index) => {
                                switch (element.type) {
                                    case "checkbox":
                                        return (
                                            <CustomCheckbox
                                                key={
                                                    index +
                                                    "initial group" +
                                                    element.name
                                                }
                                                className="search-filter"
                                                panelTitle={element.label}
                                                attribute={element.name}
                                                operator={"or"}
                                                limit={5}
                                                showMore={"true"}
                                                showMoreLimit={200}
                                            />
                                        );
                                    case "datepicker":
                                        return (
                                            <CustomDatePicker
                                                key={
                                                    index +
                                                    "initial group" +
                                                    element.name
                                                }
                                                panelTitle={element.label}
                                                attribute={element.name}
                                            />
                                        );
                                    case "range":
                                        return (
                                            <CustomRangeSlider
                                                key={
                                                    index +
                                                    "initial group" +
                                                    element.name
                                                }
                                                panelTitle={element.label}
                                                attribute={element.name}
                                                // Optional parameters
                                                unit={element.unit}
                                            />
                                        );
                                    case "category":
                                        return (
                                            <CustomCategories
                                                key={
                                                    index +
                                                    "active group" +
                                                    element.name
                                                }
                                                panelTitle={element.label}
                                                categories={element.levels}
                                            />
                                        );
                                    case "none":
                                        return null;
                                    default:
                                }
                            })}
                    </Accordion>
                );
            case "none":
                return null;

            default:
        }
    });
    const memoActiveList = activeFilters.map(
        // eslint-disable-next-line
        (element, index) => {
            switch (element.type) {
                case "checkbox":
                    return (
                        <CustomCheckbox
                            key={index + "active" + element.name}
                            className="search-filter"
                            panelTitle={element.label}
                            attribute={element.name}
                            operator={"or"}
                            limit={5}
                            showMore={"true"}
                            showMoreLimit={200}
                        />
                    );
                case "datepicker":
                    return (
                        <CustomDatePicker
                            key={index + "active" + element.name}
                            panelTitle={element.label}
                            attribute={element.name}
                        />
                    );
                case "range":
                    return (
                        <CustomRangeSlider
                            key={index + "active" + element.name}
                            panelTitle={element.label}
                            attribute={element.name}
                            // Optional parameters
                            unit={element.unit}
                        />
                    );
                case "category":
                    return (
                        <CustomCategories
                            key={index + "active" + element.name}
                            panelTitle={element.label}
                            categories={element.levels}
                            attribute={element.name}
                        />
                    );
                case "group":
                    return (
                        <Accordion
                            header={element.label}
                            group={true}
                            key={index + " active group accordion"}
                        >
                            {element.group.map(
                                // eslint-disable-next-line
                                (element, index) => {
                                    switch (element.type) {
                                        case "checkbox":
                                            return (
                                                <CustomCheckbox
                                                    key={
                                                        index +
                                                        "active group" +
                                                        element.name
                                                    }
                                                    className="search-filter"
                                                    panelTitle={element.label}
                                                    attribute={element.name}
                                                    operator={"or"}
                                                    limit={5}
                                                    showMore={"true"}
                                                    showMoreLimit={200}
                                                />
                                            );
                                        case "datepicker":
                                            return (
                                                <CustomDatePicker
                                                    key={
                                                        index +
                                                        "active group" +
                                                        element.name
                                                    }
                                                    panelTitle={element.label}
                                                    attribute={element.name}
                                                />
                                            );
                                        case "range":
                                            return (
                                                <CustomRangeSlider
                                                    key={
                                                        index +
                                                        "active group" +
                                                        element.name
                                                    }
                                                    panelTitle={element.label}
                                                    attribute={element.name}
                                                    // Optional parameters
                                                    unit={element.unit}
                                                />
                                            );
                                        case "category":
                                            return (
                                                <CustomCategories
                                                    key={
                                                        index +
                                                        "active group" +
                                                        element.name
                                                    }
                                                    panelTitle={element.label}
                                                    categories={element.levels}
                                                />
                                            );
                                        case "none":
                                            return null;
                                        default:
                                    }
                                },
                            )}
                        </Accordion>
                    );
                case "none":
                    return null;

                default:
            }
        },
    );

    return <>{showInitial ? memoInitialList : memoActiveList}</>;
};
export default CustomFilters;
